<template>
  <ion-app>
    <div class="bg-color"></div>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div :class="banner.class">
          <div class="close-banner cursor-pointer" @click="hideNutritionalTable">
            <ion-icon name="close"></ion-icon>
          </div>
          <div class="banner-content-relative pt-3">
            <p class="mb-1 text-lg ion-text-left">
              <span>{{ dish.data.namePT }}</span>
            </p>
            <p
              v-if="currentRoute === 'Meal'"
              class="mb-4 text-sm grey ion-text-left"
            >Valores de referência (%VR) baseados na sua dieta</p>
            <p
              v-else
              class="mb-4 text-sm grey ion-text-left"
            >Valores de referência (%VR) baseados em uma dieta de 2000 kcal definida pela OMS</p>
            <table class="ion-text-left text-sm">
              <thead class="bg-green white">
                <th class="p-2">Componente</th>
                <th class="p-2">Valor</th>
                <th class="p-2">% VR</th>
              </thead>
              <tbody>
                <tr class="border-tr">
                  <td class="p-2 bold">Calorias</td>
                  <td class="p-2 bold">{{nutritionalInfo.kcal.value}} kcal</td>
                  <td class="p-2 bold">{{nutritionalInfo.kcal.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2 bold">Carboidratos totais</td>
                  <td class="p-2 bold">{{nutritionalInfo.carbs.value}} g</td>
                  <td class="p-2 bold">{{nutritionalInfo.carbs.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2">Açúcares</td>
                  <td class="p-2">{{nutritionalInfo.sugar.value}} g</td>
                  <td class="p-2">{{nutritionalInfo.sugar.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Fibras alimentares</td>
                  <td class="p-2">{{nutritionalInfo.fibers.value}} g</td>
                  <td class="p-2">{{nutritionalInfo.fibers.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2 bold">Proteína</td>
                  <td class="p-2 bold">{{nutritionalInfo.protein.value}} g</td>
                  <td class="p-2 bold">{{nutritionalInfo.protein.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2 bold">Gorduras totais</td>
                  <td class="p-2 bold">{{nutritionalInfo.fat.value}} g</td>
                  <td class="p-2 bold">{{nutritionalInfo.fat.prop}}</td>
                </tr>
                <tr>
                  <td class="p-2">Gorduras saturadas</td>
                  <td class="p-2">{{nutritionalInfo.saturatedFat.value}} g</td>
                  <td class="p-2">{{nutritionalInfo.saturatedFat.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Gorduras trans</td>
                  <td class="p-2">{{nutritionalInfo.transFat.value}} mg</td>
                  <td class="p-2">{{nutritionalInfo.transFat.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Vitamina A</td>
                  <td class="p-2">{{nutritionalInfo.vitA.value}} ng</td>
                  <td class="p-2">{{nutritionalInfo.vitA.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Vitamina C</td>
                  <td class="p-2">{{nutritionalInfo.vitC.value}} mg</td>
                  <td class="p-2">{{nutritionalInfo.vitC.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Cálcio</td>
                  <td class="p-2">{{nutritionalInfo.calcium.value}} mg</td>
                  <td class="p-2">{{nutritionalInfo.calcium.prop}}</td>
                </tr>
                <tr class="border-tr">
                  <td class="p-2">Ferro</td>
                  <td class="p-2">{{nutritionalInfo.iron.value}} ng</td>
                  <td class="p-2">{{nutritionalInfo.iron.prop}}</td>
                </tr>
              </tbody>
            </table>
            <p class="mt-3 text-xs grey ion-text-left">Fonte: Wolfram Alpha</p>
          </div>
        </div>
        <div
          v-if="currentRoute !== 'Recipe'"
          class="share-button cursor-pointer"
          @click="shareRecipe"
        >
          <ion-icon name="share" class="white" mode="ios"></ion-icon>
        </div>
        <div v-if="currentRoute !== 'Recipe'" @click="gotoBack">
          <div class="back">
            <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
          </div>
        </div>
        <div class="background-image">
          <ion-img v-if="dish.data.picture" :src="dish.data.picture"></ion-img>
          <ion-img
            v-else
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
          ></ion-img>
        </div>
        <div v-if="currentRoute === 'Alternative Meal'" class="meal-menu meal-menu-select">
          <div class="meal-menu-item cursor-pointer" @click="selectAlternative">
            <ion-icon mode="ios" name="checkmark-circle" :class="like.class"></ion-icon>
            <p class="mt-0 mb-0 text-sm ion-text-center white">Selecionar</p>
          </div>
        </div>
        <div v-else-if="currentRoute === 'Meal'" class="meal-menu">
          <div class="meal-menu-item cursor-pointer" @click="likeDish">
            <ion-icon mode="ios" name="heart" class="white" :color="like.color"></ion-icon>
            <p :class="like.textClass">Adorei</p>
          </div>
          <div class="meal-menu-item cursor-pointer" @click="gotoAlternatives">
            <ion-icon mode="ios" name="albums"></ion-icon>
            <p class="mt-0 mb-0 text-sm ion-text-center white">Alternativas</p>
          </div>
          <div class="meal-menu-item cursor-pointer" @click="doneMeal">
            <ion-icon mode="ios" name="checkmark-circle" :color="done.color"></ion-icon>
            <p :class="done.textClass">Comi</p>
          </div>
        </div>
        <div v-else-if="currentRoute === 'Recipe'" class="meal-menu pb-3 pt-3">
          <div class="meal-menu-item cursor-pointer">
            <div class="download-button apple-button">
              <ion-icon name="logo-apple" mode="ios"></ion-icon>
              <p class="mt-0 mb-0 text-sm ml-1">
                <a
                  target="_blank"
                  href="https://apps.apple.com/us/app/updiet/id1484349177?l=pt#?platform=iphone"
                >Baixar na App Store</a>
              </p>
            </div>
          </div>
          <div class="meal-menu-item cursor-pointer">
            <div class="download-button apple-button">
              <ion-icon name="logo-google" mode="ios"></ion-icon>
              <p class="mt-0 mb-0 text-sm ml-1">
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.updiet"
                >Baixar na Play Store</a>
              </p>
            </div>
          </div>
        </div>
      </ion-grid>
      <div class="meal-block">
        <div class="lg-background-image">
          <ion-img v-if="dish.data.picture" :src="dish.data.picture"></ion-img>
          <ion-img
            v-else
            src="https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/dish_grey.svg?alt=media&token=a4cfabaa-54e0-458f-858b-507f74630d1c"
          ></ion-img>
        </div>
        <div class="meal">
          <p class="mt-0 mb-0 bold text-xxl dark ion-text-wrap">{{ dish.data.namePT }}</p>
          <p class="mt-4 mb-0 darkgrey text-sm ion-text-uppercase">Informações nutricionais</p>
          <p
            v-if="currentRoute === 'Recipe' || currentRoute === 'Favorite Meal'"
            class="mt-0 mb-3 grey text-xs"
          >Em comparação a uma dieta de 2.000 kcal</p>
          <p v-else class="mt-0 mb-3 grey text-xs">Em comparação à sua meta diária</p>
          <div class="nutritional-info">
            <div class="kcal-chart">
              <DailyKcalChart :chartData="chartData" :options="chartOptions" />
              <div class="kcal-legend ion-text-center">
                <p class="mt-0 kcal-margin dark text-xs bold">kcal</p>
                <p class="mt-0 mb-0 green text-sm bold">{{ dish.data.kcal }}</p>
              </div>
            </div>
            <div class="nutritional-data-block">
              <p class="dark bold data-margin">Gordura</p>
              <p class="dark bold data-margin">Proteína</p>
              <p class="mb-0 dark bold">Carbs</p>
            </div>
            <div class="nutritional-progress-block">
              <div class="nutritional-progress-indicator data-margin">
                <span :style="fatProp"></span>
                <div class="progress-tag text-xs">{{ dish.data.nutritionalInfo.fat }}g</div>
              </div>
              <div class="nutritional-progress-indicator data-margin">
                <span :style="proteinProp"></span>
                <div class="progress-tag text-xs">{{ dish.data.nutritionalInfo.protein }}g</div>
              </div>
              <div class="nutritional-progress-indicator">
                <span :style="carbsProp"></span>
                <div class="progress-tag text-xs">{{ dish.data.nutritionalInfo.carbs }}g</div>
              </div>
            </div>
          </div>
          <p class="mt-3 green thin text-sm d-flex-align-center" @click="showNutritionalTable">
            <ion-icon name="eye" class="mr-1 text-lg"></ion-icon>Tabela nutricional completa
          </p>
          <p
            v-if="beverageAndDessertOptions"
            class="mt-2 green thin text-sm d-flex-align-center"
            @click="gotoBeverages"
          >
            <ion-icon name="cafe" class="mr-1 text-lg"></ion-icon>Ver opções de bebida
          </p>
          <p
            v-if="beverageAndDessertOptions"
            class="mt-2 green thin text-sm d-flex-align-center"
            @click="gotoDesserts"
          >
            <ion-icon name="ice-cream" class="mr-1 text-lg"></ion-icon>Ver opções de sobremesa
          </p>
          <div v-if="showIngredients">
            <p class="mt-4 mb-3 darkgrey text-sm ion-text-uppercase">Ingredientes</p>
            <div v-for="(food, index) in dish.data.foodsScaled" :key="index">
              <p class="green text-lg">{{ food.data.namePT }}</p>
              <div
                class="ingredient-list mt-3 mb-3"
                v-for="ingredient in food.data.ingredients"
                :key="ingredient.id"
              >
                <div class="ingredient mt-2 mb-2">
                  <div class="dot mr-2"></div>
                  <p class="mt-0 mb-0 dark bold text-sm">
                    {{ ingredient.data.amount }} {{ ingredient.data.unit }}
                    {{ ingredient.data.namePT }}
                    <span
                      v-if="ingredient.data.comment"
                    >({{ ingredient.data.comment }})</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showPreparationSteps">
            <p class="mt-5 mb-3 darkgrey text-sm ion-text-uppercase">Como preparar</p>
            <div v-for="food in dish.data.foods" :key="food.id">
              <p class="green text-lg">{{ food.data.namePT }}</p>
              <div
                class="howto-list mt-3 mb-3"
                v-for="(preparationStep, index) in food.data.preparationSteps"
                :key="index"
              >
                <div class="howto mt-2 mb-2">
                  <div class="arrow-right mr-2"></div>
                  <p class="mt-0 mb-0 dark bold text-sm">
                    {{ preparationStep.instruction }}
                    <br />
                    <span class="green thin text-xs">({{ preparationStep.time }} min)</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-app>
</template>

<script>
// capacitor
import { Plugins } from "@capacitor/core";
const { Device } = Plugins;
const { Share } = Plugins;
// moment
import moment from "moment";
moment.locale("pt-br");
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// chart
import DailyKcalChart from "../../partials/content/DailyKcalChart.js";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// utils
import { computeDish } from "../../utils/formulas.js";
// services
import doneMealService from "@/services/meals/done-meal.js";
import milestoneService from "@/services/meals/done-meal.js";
// components
export default {
  name: "MealInfo",
  components: {
    DailyKcalChart,
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: true,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      currentRoute: this.$route.name,
      proportion: null,
      banner: {
        class: "banner-message-full p-3 d-none"
      },
      nutritionalInfo: {
        kcal: {
          value: 0,
          prop: 0
        },
        fat: {
          value: 0,
          prop: 0
        },
        saturatedFat: {
          value: 0,
          prop: 0
        },
        transFat: {
          value: 0,
          prop: 0
        },
        carbs: {
          value: 0,
          prop: 0
        },
        sugar: {
          value: 0,
          prop: 0
        },
        fibers: {
          value: 0,
          prop: 0
        },
        protein: {
          value: 0,
          prop: 0
        },
        vitA: {
          value: 0,
          prop: 0
        },
        vitC: {
          value: 0,
          prop: 0
        },
        calcium: {
          value: 0,
          prop: 0
        },
        iron: {
          value: 0,
          prop: 0
        }
      },
      mealplan: {
        done: false
      },
      alternative: false,
      dish: {
        id: this.$route.params.dishId,
        data: {
          namePT: null,
          kcal: "Calculando...",
          nutritionalInfo: {
            fat: 0,
            carbs: 0,
            protein: 0
          },
          foods: [],
          foodsScaled: []
        }
      },
      like: {
        status: false,
        color: null,
        textClass: "mt-0 mb-0 text-sm ion-text-center white"
      },
      done: {
        status: false,
        color: null,
        textClass: "mt-0 mb-0 text-sm ion-text-center white"
      },
      day: null,
      chartOptions: {
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        cutoutPercentage: 70
      },
      chartData: {},
      fatProp: 0,
      proteinProp: 0,
      carbsProp: 0,
      showIngredients: false,
      showPreparationSteps: false,
      beverageAndDessertOptions: false
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    clearBanner() {
      this.notification = {
        class: "banner-message-full p-3 d-none"
      };
    },
    gotoBack() {
      const instance = this;
      if (instance.currentRoute === "Meal") {
        const rawDay = instance.mealplan.data.day;
        const day = moment(rawDay, "DD/MM/YYYY").format("DD-MM-YYYY");
        instance.$router.push({
          name: "Meal Plan: Day",
          params: {
            day: day
          }
        });
      } else {
        instance.$router.go(-1);
      }
    },
    gotoBeverages() {
      const meal = this.$route.params.meal;
      this.$router.push({
        name: "Beverages",
        params: {
          meal: meal
        }
      });
    },
    gotoDesserts() {
      const meal = this.$route.params.meal;
      this.$router.push({
        name: "Desserts",
        params: {
          meal: meal
        }
      });
    },
    async shareRecipe() {
      const instance = this;
      const params = {
        route: "Meal",
        action: "recipeShared"
      };
      /*
      const response = await milestoneService(params);
      if (response === "ok") {
        instance.notification = {
          class: "error-message p-3",
          message: `Você atingiu uma nova conquista ao compartilhar sua primeira receita!`
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
      */
      const userId = instance.profile.id;
      await db
        .collection("users")
        .doc(userId)
        .update({
          milestoneFirstShare: true
        });
      store.state.profile.data.milestoneFirstShare = true;
      const info = await Device.getInfo();
      if (info.platform === "ios" || info.platform === "android") {
        let shareRet = await Share.share({
          title: `Olha essa receita: ${instance.dish.data.namePT}`,
          text: "Acabei de encontrar no Updiet",
          url: `https://updiet-app.firebaseapp.com/recipe/${instance.dish.id}/100`,
          dialogTitle: "Compartilhar essa receita"
        });
      } else {
        console.log(info);
      }
    },
    showNutritionalTable() {
      this.banner = {
        class: "banner-message-full p-3"
      };
    },
    hideNutritionalTable() {
      this.banner = {
        class: "banner-message-full p-3 d-none"
      };
    },
    async likeDish() {
      const instance = this;
      instance.startLoading();
      const dishId = instance.$route.params.dishId;
      // get user info
      const userId = instance.user.uid;
      let profileId = instance.profile.id;
      // update user likes
      const likes = instance.profile.data.likes;
      // update db
      if (instance.like.status) {
        for (let i = 0; i < likes.length; i++) {
          if (likes[i] === dishId) {
            likes.splice(i, 1);
          }
        }
        db.collection("dishes")
          .doc(dishId)
          .update({
            likes: firebase.firestore.FieldValue.arrayRemove(userId)
          });
        db.collection("users")
          .doc(profileId)
          .update({
            likes: likes
          });
        instance.like = {
          status: false,
          color: null,
          textClass: "mt-0 mb-0 text-sm ion-text-center white"
        };
        instance.isLoading = false;
      } else {
        likes.push(dishId);
        db.collection("dishes")
          .doc(dishId)
          .update({
            likes: firebase.firestore.FieldValue.arrayUnion(userId)
          });
        db.collection("users")
          .doc(profileId)
          .update({
            likes: likes
          });
        instance.like = {
          status: true,
          color: "dark",
          textClass: "mt-0 mb-0 text-sm ion-text-center dark"
        };
        instance.isLoading = false;
      }
      instance.profile.data.likes = likes;
      store.updateProfile(instance.profile);
    },
    async doneMeal() {
      const instance = this;
      instance.startLoading();
      const dishId = instance.$route.params.dishId;
      const mealplanId = instance.mealplan.id;
      const date = instance.mealplan.data.day;
      const meal = instance.$route.params.meal;
      const doneStatus = instance.done.status;
      const numPoints = await doneMealService({
        dishId: dishId,
        date: date,
        meal: meal,
        mealplanId: mealplanId,
        doneStatus: doneStatus
      });
      // response
      if (numPoints) {
        if (doneStatus) {
          instance.isLoading = false;
          instance.done = {
            status: false,
            color: null,
            textClass: "mt-0 mb-0 text-sm ion-text-center white"
          };
          if (numPoints) {
            let word;
            if (numPoints === 1) {
              word = "ponto";
            } else {
              word = "pontos";
            }
            instance.notification = {
              class: "error-message p-3",
              message: `Que pena... Você perdeu ${numPoints} ${word}.`
            };
            setTimeout(() => {
              instance.clearNotification();
            }, 3000);
          }
        } else {
          instance.isLoading = false;
          instance.done = {
            status: true,
            color: "dark",
            textClass: "mt-0 mb-0 text-sm ion-text-center dark"
          };
          instance.isLoading = false;
          if (numPoints) {
            let word;
            if (numPoints === 1) {
              word = "ponto";
            } else {
              word = "pontos";
            }
            instance.notification = {
              class: "error-message p-3",
              message: `Parabéns! Você ganhou ${numPoints} ${word} por completar essa refeição.`
            };
            setTimeout(() => {
              instance.clearNotification();
            }, 3000);
          }
        }
      }
    },
    gotoAlternatives() {
      this.$router.push({
        name: "Alternative Meals",
        params: {
          mealplanId: this.$route.params.mealplanId
        }
      });
    },
    async selectAlternative() {
      const instance = this;
      instance.startLoading();
      const day = instance.mealplan.data.day.replace(/\//g, "-");
      try {
        const dishId = instance.$route.params.dishId;
        const proportion = instance.$route.params.proportion;
        const mealplanId = instance.$route.params.mealplanId;
        const mpRef = db.collection("mealplans").doc(mealplanId);
        const doc = await mpRef.get();
        const data = doc.data();
        const currentSelectedDish = data.chosenDish;
        let alternatives = data.alternatives;
        for (let i = 0; i < alternatives.length; i++) {
          if (alternatives[i].id === dishId) {
            alternatives.splice(i, 1);
          }
        }
        alternatives.push(currentSelectedDish);
        const result = await db
          .collection("mealplans")
          .doc(mealplanId)
          .update({
            chosenDish: {
              id: dishId,
              proportion: proportion
            },
            alternatives: alternatives
          });
        store.state.mealplans = [];
        // update shoppingList
        const today = moment();
        const dayOfWeek = moment(today).isoWeekday();
        const fromDate = moment(today).startOf("week");
        const startDay = moment(fromDate).format("DD/MM/YYYY");
        const shopRef = db
          .collection("shoppingLists")
          .where("userId", "==", instance.user.uid)
          .where("startDay", "==", startDay);
        const snapshot = await shopRef.get();
        if (!snapshot.empty) {
          let shopId;
          snapshot.forEach(doc => {
            shopId = doc.id;
          });
          await db
            .collection("shoppingLists")
            .doc(shopId)
            .delete();
        }
        instance.isLoading = false;
      } catch (e) {
        console.log(e);
        instance.isLoading = false;
      }
      instance.isLoading = false;
      instance.$router.push({
        name: "Meal Plan: Day",
        params: {
          day: day
        }
      });
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      const route = instance.$route;
      if (
        route.params.meal === "breakfast" ||
        route.params.meal === "lunch" ||
        route.params.meal === "dinner"
      ) {
        instance.beverageAndDessertOptions = true;
      }
      const proportion = route.params.proportion;
      let id;
      let data;
      let targetKcal = 2000;
      let targetFat = 78000;
      let targetSaturatedFat = 200000;
      let targetCholesterol = 300;
      let targetCarbs = 275000;
      let targetSugar = 50000;
      let targetFibers = 28000;
      let targetProtein = 50000;
      let targetSodium = 2300000;
      let targetVitA = 900;
      let targetVitC = 90;
      let targetCalcium = 1300;
      let targetIron = 1800;
      if (route.name === "Recipe" || route.name === "Favorite Meal") {
        const dishRef = db.collection("dishes").doc(route.params.dishId);
        const doc = await dishRef.get();
        id = doc.id;
        data = doc.data();
      } else {
        if (instance.user) {
          // calculate targets
          targetKcal = instance.profile.data.target.kcal;
          targetFat = instance.profile.data.target.fat;
          targetSaturatedFat = instance.profile.data.target.saturatedFat;
          targetCholesterol = instance.profile.data.target.cholesterol;
          targetCarbs = instance.profile.data.target.carbs;
          targetSugar = instance.profile.data.target.sugar;
          targetFibers = instance.profile.data.target.fibers;
          targetProtein = instance.profile.data.target.protein;
          targetSodium = instance.profile.data.target.sodium;
          targetVitA = instance.profile.data.target.vitA;
          targetVitC = instance.profile.data.target.vitC;
          targetCalcium = instance.profile.data.target.calcium;
          targetIron = instance.profile.data.target.iron;
          const mealplanId = route.params.mealplanId;
          // get mealplan
          let mpRef = db.collection("mealplans").doc(mealplanId);
          const mpDoc = await mpRef.get();
          const mealplan = {
            id: mpDoc.id,
            data: mpDoc.data()
          };
          instance.mealplan = mealplan;
          instance.day = mealplan.data.day;
          // check if done
          if (mealplan.data.done) {
            instance.done = {
              status: true,
              color: "dark",
              textClass: "mt-0 mb-0 text-sm ion-text-center dark"
            };
          }
          // get dish
          const dishRef = db.collection("dishes").doc(route.params.dishId);
          const doc = await dishRef.get();
          id = doc.id;
          data = doc.data();
          // check likes
          if (data.likes) {
            if (data.likes.includes(instance.user.uid)) {
              instance.like = {
                status: true,
                color: "dark",
                textClass: "mt-0 mb-0 text-sm ion-text-center dark"
              };
            }
          }
        }
      }
      if (proportion !== 100) {
        instance.proportion = proportion / 100;
      }
      // computed data
      const computedData = computeDish(data, proportion);
      let fatProp = (computedData.nutritionalInfo.fat / targetFat) * 100;
      let proteinProp =
        (computedData.nutritionalInfo.protein / targetProtein) * 100;
      let carbsProp = (computedData.nutritionalInfo.carbs / targetCarbs) * 100;
      if (fatProp > 100) {
        fatProp = 100;
      }
      if (proteinProp > 100) {
        proteinProp = 100;
      }
      if (carbsProp > 100) {
        carbsProp = 100;
      }
      instance.nutritionalInfo = {
        kcal: {
          value: computedData.kcal,
          prop: `${Math.round((computedData.kcal / targetKcal) * 100)} %`
        },
        fat: {
          value: Math.round(computedData.nutritionalInfo.fat / 1000),
          prop: `${Math.round(
            (computedData.nutritionalInfo.fat / targetFat) * 100
          )} %`
        },
        saturatedFat: {
          value: Math.round(computedData.nutritionalInfo.saturatedFat / 1000),
          prop: `${Math.round(
            (computedData.nutritionalInfo.saturatedFat / targetSaturatedFat) *
              100
          )} %`
        },
        transFat: {
          value: computedData.nutritionalInfo.transFat,
          prop: `-`
        },
        cholesterol: {
          value: computedData.nutritionalInfo.cholesterol,
          prop: `${Math.round(
            (computedData.nutritionalInfo.cholesterol / targetCholesterol) * 100
          )} %`
        },
        carbs: {
          value: Math.round(computedData.nutritionalInfo.carbs / 1000),
          prop: `${Math.round(
            (computedData.nutritionalInfo.carbs / targetCarbs) * 100
          )} %`
        },
        sugar: {
          value: Math.round(computedData.nutritionalInfo.sugar / 1000),
          prop: `${Math.round(
            (computedData.nutritionalInfo.sugar / targetSugar) * 100
          )} %`
        },
        fibers: {
          value: Math.round(computedData.nutritionalInfo.fibers / 1000),
          prop: `${Math.round(
            (computedData.nutritionalInfo.fibers / targetFibers) * 100
          )} %`
        },
        protein: {
          value: Math.round(computedData.nutritionalInfo.protein / 1000),
          prop: `${Math.round(
            (computedData.nutritionalInfo.protein / targetProtein) * 100
          )} %`
        },
        sodium: {
          value: computedData.nutritionalInfo.sodium,
          prop: `${Math.round(
            (computedData.nutritionalInfo.sodium / targetSodium) * 100
          )} %`
        },
        vitA: {
          value: computedData.nutritionalInfo.vitA,
          prop: `${Math.round(
            (computedData.nutritionalInfo.vitA / targetVitA) * 100
          )} %`
        },
        vitC: {
          value: computedData.nutritionalInfo.vitC,
          prop: `${Math.round(
            (computedData.nutritionalInfo.vitC / targetVitC) * 100
          )} %`
        },
        calcium: {
          value: computedData.nutritionalInfo.calcium,
          prop: `${Math.round(
            (computedData.nutritionalInfo.calcium / targetCalcium) * 100
          )} %`
        },
        iron: {
          value: computedData.nutritionalInfo.iron,
          prop: `${Math.round(
            (computedData.nutritionalInfo.iron / targetIron) * 100
          )} %`
        }
      };
      instance.fatProp = `width: ${fatProp}%`;
      instance.proteinProp = `width: ${proteinProp}%`;
      instance.carbsProp = `width: ${carbsProp}%`;
      instance.chartData = {
        datasets: [
          {
            backgroundColor: ["#dddddd", "#19ad00"],
            data: [targetKcal - computedData.kcal, computedData.kcal]
          }
        ]
      };
      computedData.nutritionalInfo.fat = Math.round(
        computedData.nutritionalInfo.fat / 1000
      );
      computedData.nutritionalInfo.carbs = Math.round(
        computedData.nutritionalInfo.carbs / 1000
      );
      computedData.nutritionalInfo.protein = Math.round(
        computedData.nutritionalInfo.protein / 1000
      );
      if (computedData.kcal <= 0 || !computedData.kcal) {
        computedData.kcal = "Calculando...";
      }
      instance.dish = {
        id: id,
        data: computedData
      };
      if (computedData.showInfo) {
        instance.showIngredients = true;
        instance.showPreparationSteps = true;
      }
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
    instance.isLoading = false;
  }
};
</script>

<style scoped>
ion-content {
  --background: transparent !important;
}
.bg-color {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: -2;
}
.back {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: var(--standard-padding-top);
  left: 5vw;
  width: 48px;
  height: 48px;
  background: rgba(200, 200, 200, 0.5);
  border-radius: 50%;
  font-size: 1.2rem !important;
  z-index: 1020;
}
.share-button {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  top: var(--standard-padding-top);
  right: 5vw;
  width: 48px;
  height: 48px;
  background: var(--ion-color-primary);
  border-radius: 50%;
  font-size: 1.6rem;
  z-index: 1000;
}
.background-image {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%);
  text-align: center;
  width: 100%;
  z-index: -1;
}
.background-image ion-img {
  height: 300px;
  width: 100%;
  object-fit: cover;
}
.lg-background-image {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.lg-background-image ion-img {
  height: 300px;
  width: 100%;
  object-fit: cover;
}
.meal-menu {
  position: fixed;
  display: flex;
  justify-content: space-between;
  bottom: 0;
  left: 0;
  width: 100vw;
  z-index: 1000;
  background: var(--ion-color-primary);
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10vw;
  padding-right: 10vw;
}
.meal-menu-select {
  justify-content: center;
}
.meal-menu ion-icon {
  color: white;
  font-size: 24px !important;
}
.meal-block {
  position: relative;
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  margin-top: 150px;
  padding-top: 40px;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-bottom: 80px;
  border-radius: 0 50px 0 0;
  box-shadow: -6px -6px 3px -3px rgba(0, 0, 0, 0.15);
  background: white;
}
@media (min-width: 600px) {
  .background-image {
    display: none;
  }
  .lg-background-image {
    display: block;
  }
  .meal-block {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    width: 100%;
    margin-top: 0;
    max-width: var(--max-width);
    padding-top: 40px;
    padding-left: 10vw;
    padding-right: 10vw;
    padding-bottom: 80px;
    border-radius: 0;
    box-shadow: none;
    background: white;
  }
  .meal {
    margin-top: 320px;
  }
}
.ingredient {
  display: flex;
  align-items: center;
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
}
.howto {
  display: flex;
  align-items: center;
}
.arrow-right {
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  border-left: 7px solid var(--ion-color-primary);
}
.nutritional-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.kcal-chart {
  position: relative;
  height: 80px;
  width: 80px;
}
.kcal-legend {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.kcal-margin {
  margin-bottom: -2px;
}
.nutritional-data-block p {
  margin-top: 0;
  font-size: 12px;
  line-height: 8px;
}
.nutritional-progress-block div {
  margin-top: 0;
}
.data-margin {
  margin-bottom: 24px;
}
.nutritional-progress-indicator {
  position: relative;
  width: 70px;
  margin-left: 30px;
  height: 8px;
  background: #dddddd;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 5px;
  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);
}

.nutritional-progress-indicator span {
  display: block;
  height: 100%;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  background-color: var(--ion-color-primary);
  position: relative;
  overflow: hidden;
}

.progress-tag {
  position: absolute;
  top: 50%;
  left: -35px;
  width: 30px;
  text-align: center;
  transform: translate(0, -50%);
  background: var(--ion-color-primary);
  color: white;
  border-radius: 2px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 2px;
  padding-right: 2px;
}

.download-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  box-shadow: 0 6px 3px -3px rgba(0, 0, 0, 0.15);
}

.download-button p a {
  color: #222222;
}

.download-button ion-icon {
  font-size: 20px;
  color: #222222;
}

.banner-message-full {
  overflow-y: scroll;
  background: #f7f7f7;
  box-shadow: 0 -12px -6px 3px rgba(0, 0, 0, 0.15);
}

.close-banner {
  position: fixed;
  top: 60px;
  right: 20px;
  z-index: 1001;
  font-size: 2rem;
}

.banner-content-relative table {
  width: 100%;
  overflow: none;
}

.border-tr {
  border-bottom: 1px solid lightgrey;
}
</style>
